export default "__VITE_ASSET__DSOx7UNf__"